<template>
    <dialog-button v-bind="$attrs" style="background-color: #66bcff;" @click="$emit('click')">
        <slot />
    </dialog-button>
</template>

<script>
export default {
    components: {
        'dialog-button': require('./DialogButton.vue').default,
    },
};
</script>